import { useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { api } from "../api.js";
import { useAuth } from "../auth.js";
import { ThemeToggle } from "../theme.js";

export default function Login() {
  const { user, authProvider, loading, refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [params] = useSearchParams();

  // OAuth failures come back as ?error=... on the redirect.
  const oauthError = params.get("error");

  if (loading) return <div className="page muted">Loading…</div>;
  if (user) return <Navigate to="/" replace />;

  async function signIn(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post("/auth/login", { email });
      await refresh();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      {/* No top bar before sign-in, so the toggle sits with the heading. */}
      <div className="between">
        {/* The same mark the top bar shows once you are in, and a way back out:
            this is reachable from the landing page, so it needs a door home. */}
        <h1 style={{ marginBottom: 4 }}>
          <Link
            to="/"
            style={{ color: "inherit", display: "flex", alignItems: "center", gap: 10 }}
          >
            <span className="brand-mark" aria-hidden="true">
              CB
            </span>
            CodeBench
          </Link>
        </h1>
        <ThemeToggle />
      </div>
      <p className="muted" style={{ marginTop: 0 }}>Sign in to practise and submit lab assignments.</p>

      {oauthError && <div className="error-banner">{decodeURIComponent(oauthError)}</div>}
      {error && <div className="error-banner">{error}</div>}

      <div className="card">
        {authProvider === "google" ? (
          <>
            <p className="muted" style={{ marginTop: 0 }}>
              Use the Google account your teacher added to the roster.
            </p>
            <a href="/auth/google">
              <button className="primary" style={{ width: "100%" }}>
                Continue with Google
              </button>
            </a>
          </>
        ) : (
          <form onSubmit={signIn}>
            <div className="notice">
              Development sign-in: any roster email works, no password. Not usable in production.
            </div>
            <label>
              <span>Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="asha@example.edu"
                autoFocus
                required
              />
            </label>
            <button className="primary" style={{ width: "100%" }} disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
